import React from 'react';
import { Breadcrumbs, Btn, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import UsersEditForm from './UsersEditForm';

const UsersEdit = () => {
  return (
    <>
      <Breadcrumbs mainTitle="User" title="Edit user" subParent="Users" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <H5>Edit user</H5>
                <Link to="/users">
                  <Btn color="primary">Back to users</Btn>
                </Link>
              </CardHeader>
              <CardBody>
                <UsersEditForm />
              </CardBody>
              <CardFooter>
                <Btn color="primary">Edit</Btn>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UsersEdit;
